package br.com.vvrefeicoes.portal.feature.notifications

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.domain.model.AppNotification
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.X
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.dismiss
import portalvv.shared.generated.resources.notifications_banner_view
import portalvv.shared.generated.resources.notifications_modal_ack

/** Banner (prioridade média) e modal (prioridade alta) globais de notificação. */
@Composable
fun NotificationsOverlays(onOpenList: () -> Unit) {
    val controller = LocalNotifications.current
    controller.modal?.let { modal ->
        NotificationModal(notification = modal, onDismiss = controller::dismissModal)
    }
    if (controller.modal == null) {
        controller.banner?.let { banner ->
            NotificationBanner(
                notification = banner,
                onDismiss = controller::dismissBanner,
                onView = {
                    controller.open(banner.id)
                    controller.dismissBanner()
                    onOpenList()
                },
            )
        }
    }
}

@Composable
private fun NotificationBanner(
    notification: AppNotification,
    onDismiss: () -> Unit,
    onView: () -> Unit,
) {
    Surface(
        modifier = Modifier.fillMaxWidth().padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space8),
        shape = AppShapes.medium,
        color = AppPalette.Warning100,
        contentColor = AppPalette.Warning900,
    ) {
        Row(
            modifier = Modifier.padding(start = AppSpacing.space16, end = AppSpacing.space8, top = AppSpacing.space8, bottom = AppSpacing.space8),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
                Text(text = notification.title, style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.SemiBold)
                Text(
                    text = htmlToPlain(notification.body),
                    style = MaterialTheme.typography.bodySmall,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                )
            }
            AppButton(text = stringResource(Res.string.notifications_banner_view), onClick = onView, variant = PortalButtonVariant.Text)
            IconButton(onClick = onDismiss, modifier = Modifier.size(32.dp)) {
                Icon(imageVector = Lucide.X, contentDescription = stringResource(Res.string.dismiss), modifier = Modifier.size(18.dp))
            }
        }
    }
}

@Composable
private fun NotificationModal(
    notification: AppNotification,
    onDismiss: () -> Unit,
) {
    AnnouncementModal(
        title = notification.title,
        imageUrl = notification.imageUrl,
        bodyHtml = notification.body,
        onDismiss = onDismiss,
    ) {
        AppButton(text = stringResource(Res.string.notifications_modal_ack), onClick = onDismiss)
    }
}
